import I18n from 'I18n';
import PortalIdParser from 'PortalIdParser';
import http from 'hub-http/clients/apiClient';
import { getHubRpc } from 'hubs-service-types/operations';
import { createRpcClientV2 } from 'rpc-client-utils';
const rpcClient = createRpcClientV2({
  hubHttpClient: http
});
const DEFAULT_FALLBACK_DAYS = 14;

// https://tools.hubteam.com/api-catalog/services/HubsService/v1/spec/internal#operations-Hubs-get-%2Fhubs%2Fv1%2Fhubs%2F%7BhubId%7D
export const fetchHubCreationDate = async () => {
  try {
    const response = await rpcClient.call(getHubRpc, {
      pathParameters: {
        hubId: PortalIdParser.get() || 0
      }
    });
    return response.createdAt;
  } catch (error) {
    console.error('Error fetching hub creation date', error);
    // Return a date from DEFAULT_FALLBACK_DAYS ago as fallback
    return I18n.moment().subtract(DEFAULT_FALLBACK_DAYS, 'days').valueOf();
  }
};